import { Grid, InputLabel, Radio, ToggleButton } from "@mui/material"

export const FormSection = ({title, subTitle, children}) => {
    return (        
    <div>
        <div style={{paddingTop: 50, paddingBottom: 15}}>
            <b>{title}</b>
        </div>
        <div>{children}</div>
        <InputLabel>{subTitle}</InputLabel>
    </div>
    )
}

export const CustomToggleButton = ({checked, value, icon}) => {
    return (
        <ToggleButton value={value} style={{width: "100%", justifyContent: "space-between"}}>
            <Grid container lineHeight={0} alignItems={"center"} spacing={0.5}>
                <Grid item>{icon}</Grid>
                <Grid item>{value}</Grid>
            </Grid>
            <Radio size="small" checked={checked}/>
        </ToggleButton>
    )
}